<template>
  <div class="w-100 report">
    <div class="border rounded bg-gray px-4 py-4">
      <report ref="report" />
      <hr>
      <period ref="period" />
      <hr>
      <courses ref="courses" />
      <hr>
      <students ref="students" />
      <hr>
      <payment-status ref="payment" />
      <hr>
      <div class="w-100 text-center">
        <button @click="reportCSV" class="px-5 btn btn-sm btn-success mb-1"><i class="fa fa-file-csv"></i> Baixar CSV</button>
        <br>
        <button class="px-5 btn btn-sm btn-warning"><i class="fa fa-file-pdf"></i> Baixar PDF</button>
      </div>

      <!-- <div class="w-100 text-right">
        <button class="btn btn-danger"><i class="fa fa-times-circle"></i> Cancelar</button>
        <button @click="generateReport" class="btn btn-success ml-2"><i class="fa fa-check-circle"></i> Gerar Relório</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import Period from './Filter/DatePeriod'
import Courses from './Filter/Courses'
import Students from './Filter/Students'
import ReportType from './Filter/ReportType'
import PaymentStatus from './Filter/Payment'
import Status from './Return/Status'
import { getCookie } from '@/cookiesHandler'

export default {
  components: {
    "report": ReportType,
    period: Period,
    courses: Courses,
    students: Students,
    "payment-status": PaymentStatus,
    status: Status
  },
  data () {
    return {
      loading: 'X',
      reportResponse: undefined
    }
  },
  methods: {
    reportCSV: function () {
      let token = getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00')
      let name = 'Sell'

      // let filters = {
      //   report: this.refs.report,
      //   period: this.refs.period,
      //   courses: this.refs.courses,
      //   students: this.refs.students,
      //   payment: this.refs.payment,
      // }
      window.open(`${process.env.VUE_APP_REPORT}/teacher/print/csv?name=${name}&token=${token}`, '_blank')
    },

    generateReport: function () {
      this.loading = 'W'
      Axios.get('/teacher/report/sells')
        .then( res => {
          this.loading = 'C'
          this.reportResponse = res.data
        })
        .catch( err => {
          console.error(err)
          this.loading = 'E'
        })
    }
  }
}
</script>

<style>

</style>
